import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import updateFolderRequest from 'owa-service/lib/factory/updateFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import calendarFolder from 'owa-service/lib/factory/calendarFolder';
import folderId from 'owa-service/lib/factory/folderId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateFolderOperation from 'owa-service/lib/operation/updateFolderOperation';

export default function updateAgendaMailOptionService(
    foldersToEnableAgendaMail: string[],
    foldersToDisableAgendaMail: string[]
): Promise<FolderInfoResponseMessage> {
    const folderChanges = createFolderChanges(
        foldersToEnableAgendaMail,
        foldersToDisableAgendaMail
    );

    return updateFolderOperation({
        Header: getJsonRequestHeader(),
        Body: updateFolderRequest({
            FolderChanges: folderChanges,
        }),
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}

function createFolderChanges(
    foldersToEnableAgendaMail: string[],
    foldersToDisableAgendaMail: string[]
) {
    const folderChanges = [];
    foldersToEnableAgendaMail.forEach(curFolderId => {
        folderChanges.push({
            Updates: [
                setFolderField({
                    Path: propertyUri({
                        FieldURI: 'AgendaMailDisabled',
                    }),
                    Folder: calendarFolder({
                        AgendaMailDisabled: false,
                    }),
                }),
            ],
            FolderId: folderId({ Id: curFolderId }),
        });
    });

    foldersToDisableAgendaMail.forEach(curFolderId => {
        folderChanges.push({
            Updates: [
                setFolderField({
                    Path: propertyUri({
                        FieldURI: 'AgendaMailDisabled',
                    }),
                    Folder: calendarFolder({
                        AgendaMailDisabled: true,
                    }),
                }),
            ],
            FolderId: folderId({ Id: curFolderId }),
        });
    });

    return folderChanges;
}
